// extracted by mini-css-extract-plugin
export default {"textNoMatches":"uuPeYqL9Cwae6D7-bA9zsQ==","icon":"JSgtJvfDsBVZjy5yabyffQ=="};